<script>
import detectIE from '../../../utils/detectIE.js';

export default {
  name: 'PredictorSelection',
  props: {
    isClockwise: {
      type: Boolean,
      default: true,
    },
    selectionWidth: {
      type: Number,
      required: true,
    },
    selectionWidthPercentage: {
      type: Number,
      required: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    barrierNumber: {
      type: Number,
      required: true,
    },
    competitorNumber: {
      type: Number,
      required: true,
    },
    silkUrl: {
      type: String,
      required: true,
    },
    selectionName: {
      type: String,
      required: true,
    },
    ranking: {
      type: String,
      required: true,
    },
    bestOdds: {
      type: [Number, null],
      default: 0,
    },
    selectionId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      textDefaultPosition: 50,
    };
  },
  computed: {
    selectionTextMarginStyle() {
      const marginDirection = this.isClockwise ? 'margin-left' : 'margin-right';
      return `${marginDirection}: ${this.textDefaultPosition}px`;
    },
    widthPercentage() {
      return `${(this.selectionWidthPercentage * 100).toFixed()}%`;
    },
    isIE() {
      return detectIE();
    },
    selectionClassList() {
      return [
        { 'predictor__selection--anti-clockwise': !this.isClockwise },
        'predictor__selection',
        'display-runnercard',
      ];
    },
  },
  watch: {
    selectionWidth() {
      this.handleTextPosition();
    },
  },
  mounted() {
    this.handleTextPosition();
  },
  methods: {
    handleTextPosition() {
      const { selectionWidth, isMobile, bestOdds } = this;
      const { selectionText } = this.$refs;
      let textWidth = selectionText.clientWidth;
      // workaround for Punters client side rendering defects.
      if (textWidth === 0) {
        if (isMobile) {
          textWidth = bestOdds ? 160 : 120;
        }
        if (!isMobile) {
          textWidth = bestOdds ? 250 : 210;
        }
      }
      const widthOfTextInSelection = isMobile ? selectionWidth - 56 : selectionWidth - 100;
      const isTextTooLong = textWidth > widthOfTextInSelection;
      const CUSHION = 10;
      const DEFAULT_POSITION = 50;
      this.textDefaultPosition = isTextTooLong ? -1 * (textWidth + CUSHION) : DEFAULT_POSITION;
    },
  },
};
</script>

<template>
  <div
    :style="`width: ${selectionWidth}px`"
    :class="selectionClassList"
    :data-ranking="ranking"
    :data-percentage="widthPercentage"
    :data-sid="selectionId"
  >
    <div class="predictor__selection-meta">
      <div :class="[{ 'selection-silk-wrap--is-ie': isIE }, 'predictor__selection-silk-wrap']">
        <img :src="silkUrl" class="predictor__selection-silk" >
      </div>
      <div ref="selectionText" :style="`${selectionTextMarginStyle}`" class="predictor__selection-text">
        <p class="predictor__selection-competitor-number predictor__selection-meta">{{ competitorNumber }}.</p>
        <p class="predictor__selection-name predictor__selection-meta">{{ selectionName }}</p>
        <p v-if="bestOdds !== 0" class="predictor__selection-odds predictor__selection-meta">
          ${{ bestOdds | twoDecimalPlaces }}
        </p>
        <p v-if="!isMobile && widthPercentage" class="predictor__selection-percentage predictor__selection-meta">
          ({{ widthPercentage }})
        </p>
      </div>
    </div>
    <p class="predictor__selection-barrier-number">{{ barrierNumber }}</p>
  </div>
</template>
